/**
 * Écran de chargement : logo Secura animé à chaque affichage.
 */
import React, { useEffect } from 'react';
import { logoSecura } from '../../assets/assets';

const SplashScreen = ({ onComplete, message, duration }) => {
  const totalDuration = duration ?? 2800;

  useEffect(() => {
    const timer = setTimeout(() => {
      onComplete?.();
    }, totalDuration);
    return () => clearTimeout(timer);
  }, [onComplete]);

  return (
    <>
      <style>{`
        @keyframes securaLogoIn {
          0% { opacity: 0; transform: scale(0.88) translateY(8px); }
          45% { opacity: 1; transform: scale(1.04) translateY(0); }
          70% { transform: scale(0.98); }
          100% { opacity: 1; transform: scale(1); }
        }
        @keyframes securaLogoPulse {
          0%, 100% { opacity: 1; transform: scale(1); filter: drop-shadow(0 0 0 rgba(0, 38, 226, 0)); }
          50% { opacity: 0.92; transform: scale(1.045); filter: drop-shadow(0 8px 24px rgba(0, 38, 226, 0.28)); }
        }
        .secura-splash-logo {
          animation:
            securaLogoIn 0.7s cubic-bezier(0.22, 1, 0.36, 1) both,
            securaLogoPulse 1.4s ease-in-out 0.7s infinite;
        }
      `}</style>
      <div className="fixed inset-0 z-[9999] flex flex-col items-center justify-center overflow-hidden bg-white">
        <div className="relative px-8">
          <img
            src={logoSecura}
            alt="Secura"
            className="secura-splash-logo w-48 h-48 md:w-56 md:h-56 lg:w-64 lg:h-64 object-contain"
          />
          {message ? (
            <p className="absolute left-1/2 top-[66%] w-[min(28rem,88vw)] -translate-x-1/2 text-center text-sm leading-snug text-gray-600">{message}</p>
          ) : null}
        </div>
      </div>
    </>
  );
};

export default SplashScreen;
